/* eslint-disable no-confusing-arrow */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFieldArray } from 'react-hook-form';
import { TextField, Button } from '@mui/material';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { dayjs } from '../../../utils/functions';
import { DatePicker, DateTimePicker } from '../../Datepicker';
import { useEffect } from 'react';
const FinishMainatenanceOrderForm = ({ control, errors, maintenanceOrder }) => {
  const information = useSelector((state) => state.information);
  const {
    setting: { cmms: cmmsSetting },
  } = information;

  const [detailTopic, setDetailTopic] = useState('');
  const [notifie, setNotifie] = useState();

  // ===== useFieldArray สำหรับ "ขั้นตอนการปฏิบัติงาน" เดิม =====
  const {
    fields: processFields,
    append: appendProcess,
    remove: removeProcess,
  } = useFieldArray({
    control,
    name: 'process',
  });

  // ===== useFieldArray ใหม่สำหรับ "วิธีการแก้ไข" =====
  const {
    fields: modifyFields,
    append: appendModify,
    remove: removeModify,
  } = useFieldArray({
    control,
    name: 'modify_new', // จะได้เป็น modify[0].method, modify[1].method, ...
  });
  useEffect(() => {
    // ถ้ามี modify_new ใน maintenanceOrder และ array ยังว่าง → seed จาก modify_new
    if (maintenanceOrder?.modify_new?.length && modifyFields.length === 0) {
      maintenanceOrder.modify_new.forEach((item) => {
        appendModify(
          { operating: item.operating || '' },
          { shouldFocus: false },
        );
      });
    } else if (maintenanceOrder?.modify && modifyFields.length === 0) {
      // ถ้าไม่มี modify_new แต่มี modify เดิม → seed จาก modify
      appendModify(
        { operating: maintenanceOrder.modify },
        { shouldFocus: false },
      );
    }
  }, [maintenanceOrder, modifyFields.length, appendModify]);

  return (
    <div className="flex flex-wrap">
      <div className="w-full ">
        <div className="w-full px-1 my-2 py-2 font-semibold text-lg">
          รายละเอียดหลังแจ้งซ่อม
        </div>
        <div className="grid grid-cols-2 w-full">
          <div className="w-full  my-2 px-1 flex-wrap">
            <Controller
              name="date.workorder"
              control={control}
              defaultValue={maintenanceOrder?.date?.workorder || null}
              render={({ field }) => (
                <DatePicker
                  label="วันที่สั่งงาน(ถ้ามี)"
                  value={field.value}
                  setValue={(value) => field.onChange(value)}
                />
              )}
            />
          </div>
          <div className="w-full  my-2 px-1 flex-wrap">
            <Controller
              name="date.medium"
              control={control}
              defaultValue={maintenanceOrder?.date?.medium || null}
              render={({ field }) => (
                <DatePicker
                  label="เลื่อนแผ่น(ถ้ามี)"
                  value={field.value}
                  setValue={(value) => field.onChange(value)}
                />
              )}
            />
          </div>
          <div />
        </div>

        <div className="grid grid-cols-2 w-full">
          <div className="w-full px-1 my-2 flex-wrap">
            <Controller
              name="end_date"
              control={control}
              defaultValue={
                maintenanceOrder?.end_date
                  ? dayjs(maintenanceOrder?.end_date).format('YYYY-MM-DDTHH:mm')
                  : null
              }
              render={({ field }) =>
                cmmsSetting?.attach_time ? (
                  <DateTimePicker
                    label="วันที่ซ่อมเสร็จ"
                    value={field.value}
                    setValue={(value) => field.onChange(value)}
                  />
                ) : (
                  <DatePicker
                    label="วันที่ซ่อมเสร็จ"
                    value={field.value}
                    setValue={(value) => field.onChange(value)}
                  />
                )
              }
            />
          </div>

          <div className="w-full  px-1 my-2 flex-wrap">
            <Controller
              name="date.success"
              control={control}
              defaultValue={
                maintenanceOrder?.date?.success
                  ? dayjs(maintenanceOrder?.date?.success).format(
                      'YYYY-MM-DDTHH:mm',
                    )
                  : null
              }
              render={({ field }) => (
                <DatePicker
                  label="วันที่เก็บงาน(ถ้ามี)"
                  value={field.value}
                  setValue={(value) => field.onChange(value)}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 w-full ">
        <div className="w-full py-2 px-1">
          <Controller
            name="notifier"
            control={control}
            defaultValue={maintenanceOrder?.notifier || ''}
            render={({ field }) => (
              <TextField
                {...field}
                multiline
                label="ผู้รับแจ้ง(ถ้ามี)"
                fullWidth
                helperText={errors.modify && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>

        <div className="w-full py-2 px-1 ">
          <Controller
            name="workrecip"
            control={control}
            defaultValue={maintenanceOrder?.workrecip || ''}
            render={({ field }) => (
              <TextField
                {...field}
                multiline
                label="ผู้รับงาน(ถ้ามี)"
                fullWidth
                helperText={errors.modify && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>

        <div className="w-full  px-1 ">
          <Controller
            name="approvemaintain"
            control={control}
            defaultValue={maintenanceOrder?.approvemaintain || ''}
            render={({ field }) => (
              <TextField
                {...field}
                multiline
                label="ผู้อนุมัติ(ถ้ามี)"
                fullWidth
                size="small"
                helperText={errors.modify && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>

        <div className="w-full px-1 flex-wrap ">
          <Controller
            name="date_approve"
            control={control}
            defaultValue={
              maintenanceOrder?.date_approve
                ? dayjs(maintenanceOrder?.date_approve).format(
                    'YYYY-MM-DDTHH:mm',
                  )
                : null
            }
            render={({ field }) => (
              <DatePicker
                label="วันที่อนุมัติ"
                value={field.value}
                setValue={(value) => field.onChange(value)}
              />
            )}
          />
        </div>
      </div>

      {/* ====== วิธีกาารแก้ไข (เปลี่ยนเป็น useFieldArray) ====== */}
      <div className="w-full px-1 py-2">
        <div className="w-full px-1 my-2 py-2 font-semibold text-sm">
          วิธีการแก้ไข
        </div>

        {modifyFields.map((eachField, index) => (
          <div className="py-2" key={eachField.id}>
            <div className="flex">
              <div className="p-2 mt-2">{index + 1}</div>
              <Controller
                name={`modify_new[${index}].operating`}
                control={control}
                defaultValue={eachField.method || ''}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="วิธีการแก้ไข"
                    fullWidth
                    multiline
                  />
                )}
              />
              <Button
                type="button"
                onClick={() => removeModify(index)}
                className="ml-2"
              >
                ลบ
              </Button>
            </div>
          </div>
        ))}

        <Button
          type="button"
          onClick={() => appendModify({ method: '' })}
          className="mt-2"
        >
          เพิ่มวิธีการแก้ไข
        </Button>
      </div>

      {/* ความคิดเห็นเดิม ยังเป็นช่องเดียว */}
      <div className="w-full px-1 py-2">
        <Controller
          name="comment"
          control={control}
          defaultValue={maintenanceOrder?.comment || ''}
          render={({ field }) => (
            <TextField
              {...field}
              multiline
              rows={2}
              label="ความคิดเห็น(ถ้ามี)"
              fullWidth
              helperText={errors.comment && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>

      {/* ====== ขั้นตอนการปฏิบัติงาน เดิม (เปลี่ยนไปใช้ processFields) ====== */}
      <div className="w-full px-1 py-2">
        <div className="w-full px-1 my-2 py-2 font-semibold text-sm">
          ขั้นตอนการปฏิบัติงาน
        </div>

        {processFields.map((eachField, index) => (
          <div className="py-2" key={eachField.id}>
            <div className="flex">
              <div className="p-2 mt-2">{index + 1}</div>
              <Controller
                name={`process[${index}].operating`}
                control={control}
                defaultValue={eachField.operating || ''}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="ขั้นตอนการปฏิบัติงาน"
                    fullWidth
                  />
                )}
              />
              <Button
                type="button"
                onClick={() => removeProcess(index)}
                className="ml-2"
              >
                ลบ
              </Button>
            </div>
          </div>
        ))}

        <Button
          type="button"
          onClick={() => appendProcess({ operating: '' })}
          className="mt-2"
        >
          เพิ่มขั้นตอน
        </Button>
      </div>
    </div>
  );
};

FinishMainatenanceOrderForm.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  maintenanceOrder: PropTypes.object,
};

export default FinishMainatenanceOrderForm;
